export default __webpack_public_path__ + "static/media/Dentist Park- Ma (1).4601f341.png";